'use strict';

const TimePickerPresenter = require('../presenters/timepicker');

const PickerView = require('./picker');

const TimesView = require('./times');

class TimePickerView extends PickerView {
  initialize() {
    this.presenter = TimePickerPresenter;
    this.contentView = TimesView;
    this.templateName = 'timepicker';
    this.setModule('glive_booking_redesign');
  }

  attributes() {
    return { 'data-bhw': 'GliveBookingDealBookerTimes' };
  }

  className() {
    return 'picker glive-picker collapsed times';
  }
}

module.exports = TimePickerView;
